import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { WebServer } from "./WebServer";

import { BehaviorSubject } from "rxjs";
import { APIClient } from "./APIClient";
import { map } from "rxjs/operators";
@Injectable({
  providedIn: "root",
})
export class APIService {
  // tslint:disable-next-line:max-line-length
  constructor(
    public http: HttpClient,
    public apiClient: APIClient,
    public webServer: WebServer
  ) {}

  //login 1
  login(LoginData: any) {
    return this.apiClient.post(this.webServer.login, LoginData);
  }

  //register 2
  registerData(registerData: any) {
    return this.apiClient.post(this.webServer.registerData, registerData);
  }

  //getAllStates 3
  getStates() {
    return this.apiClient.get(this.webServer.getStates, "");
  }

  //getAllCities 4
  getcitys(id) {
    return this.apiClient.post(this.webServer.getcities, id);
  }

  //getAllDoctors 5
  getAllDoctors(cityid) {
    return this.apiClient.post(this.webServer.getAllDoctors, {
      _cityId: cityid,
    });
  }

  // getTwilioToken 6
  getTwilioToken(randomIdentity: any) {
    return this.apiClient.get(
      this.webServer.getTwilioToken + "?identity=" + randomIdentity,
      ""
    );
  }

  //getUpcomingAppointments 7
  getUpcomingAppointments(data) {
    return this.apiClient.post(this.webServer.getUpcomingAppointments, data);
  }

  //getPastAppointments 8
  getPastAppointments(data) {
    return this.apiClient.post(this.webServer.getPastAppointments, data);
  }

  //getPastAppointments 8
  createOrderID(data) {
    return this.apiClient.post(this.webServer.createOrderID, data);
  }

  //getSlots 9
  getSlots(data) {
    return this.apiClient.post(this.webServer.getSlots, data);
  }

  //addpatient 9
  addpatient(data) {
    return this.apiClient.post(this.webServer.addpatient, data);
  }

  //addAppointment 9
  addAppointment(data) {
    return this.apiClient.post(this.webServer.addAppointment, data);
  }

  //get_razorAcc 9
  get_razorAcc(data) {
    return this.apiClient.post(this.webServer.get_razorAcc, data);
  }

  // transferOnResp
  transferOnResp(data) {
    return this.apiClient.post(this.webServer.transferOnResp, data);
  }

  // transferOnResp
  sendMessage(data) {
    return this.apiClient.post(this.webServer.sendMessage, data);
  }

  // updatePatent
  updatePatent(data) {
    return this.apiClient.post(this.webServer.updatePatent, data);
  }

  //forgotpassword
  forgotpassword(data) {
    return this.apiClient.post(this.webServer.forgotpassword, data);
  }

  //PatentNewOtp
  PatentNewOtp(data) {
    return this.apiClient.post(this.webServer.PatentNewOtp, data);
  }

  //PatentNewOtpLogin
  PatentNewOtpLogin(data) {
    return this.apiClient.post(this.webServer.PatentNewOtpLogin, data);
  }

  //otpregister
  otpregister(data) {
    return this.apiClient.post(this.webServer.otpregister, data);
  }

  //updateFCM
  // updateFCM(data) {
  //   return this.apiClient.post(this.webServer.updateFCM,data);
  // }

  //add_Appoinment
  add_Appoinment(data) {
    return this.apiClient.post(this.webServer.add_Appoinment, data);
  }

  // checkUpdate
  checkUpdate(data) {
    return this.apiClient.post(this.webServer.checkUpdate, data);
  }

  // bookAppointment
  bookAppointment(data) {
    return this.apiClient.post(this.webServer.bookAppointment, data);
  }

  // getPatientAppointments
  getPatientAppointments(data) {
    return this.apiClient.post(this.webServer.getPatientAppointments, data);
  }

  // cancelAppointment
  cancelAppointment(data) {
    return this.apiClient.post(this.webServer.cancelAppointment, data);
  }

  // resheduleAppointment
  resheduleAppointment(data) {
    return this.apiClient.post(this.webServer.resheduleAppointment, data);
  }

  // updatefcmToken
  updatefcmToken(data) {
    return this.apiClient.post(this.webServer.updatefcmToken, data);
  }

  // callReject
  callReject(data) {
    return this.apiClient.post(this.webServer.callReject, data);
  }

  //getspecificdoctor
  getspecificDoctor(data){
    return this.apiClient.post(this.webServer.getspecificDoctor, data)
  }

  //essenseApi
  essenseApi() {
    return this.http
      .get("https://essence.vytal.in/home/versionCheck")
      .pipe(map((results) => results));
  }
}
